import React, { useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import { FirmwareContext } from "../../context/FirmwareContext";
import "./firmware.css";
import Button from "../button/Button";

import { initMercadoPago, Wallet } from '@mercadopago/sdk-react'

const Firmware = () => {

  initMercadoPago('APP_USR-9ad1c203-2ac1-4c0a-a784-b6c65e1ea59f', { locale: 'es-AR' });

  const location = useLocation();
  const firmwares = useContext(FirmwareContext);
  const pathnameParts = location.pathname.split("/");

  const brand = decodeURIComponent(pathnameParts[2]);
  const model = decodeURIComponent(pathnameParts[3]);
  const instalation = decodeURIComponent(pathnameParts[4]);

  const [ preferenceId, setPreferenceId ] = useState(null);

  const firmwareData = firmwares
    .filter((fw) => fw.brand === brand && fw.model === model && fw.instalation === instalation)
    .map((fw) => ({
      brand: fw.brand,
      model: fw.model,
      version: fw.version,
      instalation: fw.instalation,
      link: fw.link,
      price: 6999,
    }));

    const createPreference = async () => {

      const payload = {
        items: [
          {
            title: `Firmware ${firmwareData[0].brand} ${firmwareData[0].model} - Instalación ${firmwareData[0].instalation}`,
            description: encodeURIComponent(firmwareData[0].link),
            price: firmwareData[0].price,
          }
        ],
      };

      try {
        const response = await fetch("https://pagina-firmware.onrender.com/create_preference", {
          method: "POST",
          headers: {
            "Content-type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error ("Error en la respuesta del servidor.");
        }
        
        const data = await response.json();
        return data.id; 

      } catch (error) {
        console.error("Error al crear la preferencia:", error.message);
      }
    };

  const handleBuy = async () => {
    const id = await createPreference();
    if (id) {
      setPreferenceId(id);
    } else {
      console.log("No se pudo obtener un ID valido")
    }
  };

  if (!firmwareData.length === 0) {
    return <div>No se encontró el firmware</div>;
  }

  return (
    <div className="firmware-container">
      <Button route={`/brands/${brand}`} text="Atrás" />
      <div className="firmware-card-container">
        <div className="firmware-card">
          <h1 className="firmware-title">Datos del Firmware</h1>
          {firmwareData.map((data, index) => (
            <div key={index} className="info-card">

              <h2 className="firmware-item">{data.brand} {data.model}</h2>

              <div className="firmware-disclaimer-container">
                <p className="firmware-info">Versión/es:</p>
                <p className="firmware-data">
                  {
                    data.version ? data.version : "No Especificada"
                  }
                </p>
              </div>

              <div className="firmware-info-container">
                <p className="firmware-info">Modo de Instalación:</p> <p className="firmware-data">{data.instalation}</p>
              </div>

              <div className="firmware-disclaimer-container">
                <p className="firmware-info firmware-info-disclaimer">
                  Leer antes de comprar
                </p>
                <p className="firmware-data firmware-data-disclaimer">
                  Al momento de acreditarse el pago, se envía automáticamente al correo asociado con su Mercado Pago un link de descarga que contiene el archivo del Firmware con sus instrucciones de instalación. Puede ser que llegue al Buzón de Entrada o a Correo No Deseado.
                </p>
                <p className="firmware-data firmware-data-disclaimer">
                  Los archivos están probados y funcionan, de no solucionar su falla o problema querrá decir que el inconveniente no es de software o no puede ser solucionado con esta herramienta.
                </p>
                <p className="firmware-data firmware-data-disclaimer">
                  Tener en cuenta que se deben tener conocimientos de computación para su descarga, solo se vende y envía el Firmware, sin mano de obra.
                </p>
              </div>

              <div className="firmware-price-container">
                <p className="firmware-info">Precio:</p>
                {/* <p className="firmware-price-old">$7999</p> */}
                <p className="firmware-price-actual">${data.price}</p>
              </div>

              <button id="wallet_container" onClick={handleBuy} >Continuar al pago</button>

              { preferenceId && (
              <Wallet 
              initialization={{ preferenceId: preferenceId, redirectMode: "blank" }} 
              customization={{ texts:{ valueProp: 'smart_option'}}} 
              />
              )}

            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Firmware;
